import { rgbaArray } from '@app/engine/core/interfaces';

export const defaultColorSettings = {
  version: '1.4.7', // Bumped to invalidate cached colors after the RCS plasma palette + new vmag/rcs slug additions (rcsXXXSmall, rcsXLarge, vmagBright2…). Without this bump, existing users keep the old yellow rcsUnknown / red rcsXXSmall etc. from localStorage.
  length: 0,
  facility: [0.0, 0.64, 0.64, 1.0] as rgbaArray,
  sunlight100: [1.0, 1.0, 1.0, 0.7] as rgbaArray,
  sunlight80: [1.0, 1.0, 1.0, 0.4] as rgbaArray,
  sunlight60: [1.0, 1.0, 1.0, 0.1] as rgbaArray,
  starHi: [1.0, 1.0, 1.0, 1.0] as rgbaArray,
  starMed: [1.0, 1.0, 1.0, 0.85] as rgbaArray,
  starLow: [1.0, 1.0, 1.0, 0.65] as rgbaArray,
  sensor: [1.0, 0.0, 0.0, 1.0] as rgbaArray,
  sensorAlt: [0.0, 0.0, 1.0, 1.0] as rgbaArray,
  marker: [
    [0.2, 1.0, 1.0, 1.0] as rgbaArray,
    [1.0, 0.2, 1.0, 1.0] as rgbaArray,
    [1.0, 1.0, 0.2, 1.0] as rgbaArray,
    [0.2, 0.2, 1.0, 1.0] as rgbaArray,
    [0.2, 1.0, 0.2, 1.0] as rgbaArray,
    [1.0, 0.2, 0.2, 1.0] as rgbaArray,
    [0.5, 0.6, 1.0, 1.0] as rgbaArray,
    [0.6, 0.5, 1.0, 1.0] as rgbaArray,
    [1.0, 0.6, 0.5, 1.0] as rgbaArray,
    [1.0, 1.0, 1.0, 1.0] as rgbaArray,
    [0.2, 1.0, 1.0, 1.0] as rgbaArray,
    [1.0, 0.2, 1.0, 1.0] as rgbaArray,
    [1.0, 1.0, 0.2, 1.0] as rgbaArray,
    [0.2, 0.2, 1.0, 1.0] as rgbaArray,
    [0.2, 1.0, 0.2, 1.0] as rgbaArray,
    [1.0, 0.2, 0.2, 1.0] as rgbaArray,
    [0.5, 0.6, 1.0, 1.0] as rgbaArray,
    [0.6, 0.5, 1.0, 1.0] as rgbaArray,
  ],
  deselected: [1.0, 1.0, 1.0, 0] as rgbaArray,
  inFOV: [0.85, 0.5, 0.0, 1.0] as rgbaArray,
  inFOVAlt: [0.2, 0.4, 1.0, 1] as rgbaArray,
  payload: [0.2, 1.0, 0.0, 0.5] as rgbaArray,
  rocketBody: [0.2, 0.4, 1.0, 1] as rgbaArray,
  debris: [0.5, 0.5, 0.5, 1] as rgbaArray,
  unknown: [0.5, 0.5, 0.5, 0.85] as rgbaArray,
  pink: [1.0, 0.0, 0.6, 1.0] as rgbaArray,
  analyst: [1.0, 1.0, 1.0, 0.8] as rgbaArray,
  missile: [1.0, 1.0, 0.0, 1.0] as rgbaArray,
  missileInview: [1.0, 0.0, 0.0, 1.0] as rgbaArray,
  transparent: [1.0, 1.0, 1.0, 0.1] as rgbaArray,
  satHi: [1.0, 1.0, 1.0, 1.0] as rgbaArray,
  satMed: [1.0, 1.0, 1.0, 0.8] as rgbaArray,
  satLow: [1.0, 1.0, 1.0, 0.6] as rgbaArray,
  sunlightInview: [0.85, 0.5, 0.0, 1.0] as rgbaArray,
  penumbral: [1.0, 1.0, 1.0, 0.3] as rgbaArray,
  umbral: [1.0, 1.0, 1.0, 0.1] as rgbaArray,
  /*
   * DEBUG Colors
   * sunlight = [0.2, 0.4, 1.0, 1]
   * penumbral = [0.5, 0.5, 0.5, 0.85]
   * umbral = [0.2, 1.0, 0.0, 0.5]
   */
  gradientAmt: 0,
  /*
   * Gradients Must be Edited in color-scheme.js
   * apogeeGradient = [1.0 - this.colors.gradientAmt, this.colors.gradientAmt, 0.0, 1.0]
   * velGradient = [1.0 - this.colors.gradientAmt, this.colors.gradientAmt, 0.0, 1.0]
   */
  satSmall: [0.2, 1.0, 0.0, 0.65] as rgbaArray,
  confidenceHi: [0.0, 1.0, 0.0, 0.65] as rgbaArray,
  confidenceMed: [1.0, 0.4, 0.0, 0.65] as rgbaArray,
  confidenceLow: [1.0, 0.0, 0.0, 0.65] as rgbaArray,
  // Plasma palette, sampled at 7 evenly-spaced points (smallest → largest RCS).
  // Distinct hue family from vmag's viridis so the active scheme reads at a glance.
  rcsXXXSmall: [0.051, 0.031, 0.53, 0.9] as rgbaArray,
  rcsXXSmall: [0.38, 0.0, 0.659, 0.9] as rgbaArray,
  rcsXSmall: [0.62, 0.06, 0.624, 0.9] as rgbaArray,
  rcsSmall: [0.798, 0.28, 0.47, 0.9] as rgbaArray,
  rcsMed: [0.929, 0.473, 0.327, 0.9] as rgbaArray,
  rcsLarge: [0.987, 0.682, 0.219, 0.9] as rgbaArray,
  rcsXLarge: [0.941, 0.976, 0.129, 0.9] as rgbaArray,
  rcsUnknown: [0.5, 0.5, 0.5, 0.4] as rgbaArray,
  lostobjects: [1, 0, 0, 0.8] as rgbaArray,
  inGroup: [1.0, 0.0, 0.0, 1.0] as rgbaArray,
  countryPRC: [1.0, 0, 0, 0.6] as rgbaArray,
  countryUS: [0.2, 0.4, 1.0, 1] as rgbaArray,
  countryCIS: [1.0, 1.0, 1.0, 1.0] as rgbaArray,
  countryOther: [0, 1.0, 0, 0.6] as rgbaArray,
  densityPayload: [0.15, 0.7, 0.8, 1.0] as rgbaArray,
  spatialDensityHi: [1, 0, 0, 1] as rgbaArray,
  spatialDensityMed: [1, 0.4, 0, 1] as rgbaArray,
  spatialDensityLow: [1, 1, 0, 0.9] as rgbaArray,
  spatialDensityOther: [0.8, 0.8, 0.8, 0.3] as rgbaArray,
  notional: [1, 0, 0, 0.8] as rgbaArray,
  starlink: [0.0, 0.8, 0.0, 0.8] as rgbaArray,
  starlinkNot: [0.8, 0.0, 0.0, 0.8] as rgbaArray,
  vmagBright: [0.992, 0.906, 0.145, 0.9] as rgbaArray,
  vmagBright2: [0.369, 0.788, 0.38, 0.9] as rgbaArray,
  vmagMed1: [0.125, 0.569, 0.549, 0.9] as rgbaArray,
  vmagMed2: [0.192, 0.408, 0.557, 0.9] as rgbaArray,
  vmagDim1: [0.243, 0.286, 0.537, 0.9] as rgbaArray,
  vmagDim2: [0.286, 0.137, 0.455, 0.9] as rgbaArray,
  vmagFaint: [0.267, 0.004, 0.329, 0.9] as rgbaArray,
  vmagUnknown: [0.5, 0.5, 0.5, 0.4] as rgbaArray,
};
